// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canUpdateSecurityModel } from "./check";

export function useCanUpdateSecurityModel(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canUpdateSecurityModel(withinScope);
  return canDoAction;
}
